import { render, staticRenderFns } from "./index.vue?vue&type=template&id=22367867&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=22367867&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=22367867&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22367867",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22367867')) {
      api.createRecord('22367867', component.options)
    } else {
      api.reload('22367867', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=22367867&scoped=true", function () {
      api.rerender('22367867', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/systemMessagePopUp/index.vue"
export default component.exports